export default __webpack_public_path__ + "static/media/480_dummy2016-streetfashion01-de.d4c4cc26.png";